import { render, staticRenderFns } from "./MyHeader.vue?vue&type=template&id=74d96886&"
import script from "./MyHeader.vue?vue&type=script&lang=js&"
export * from "./MyHeader.vue?vue&type=script&lang=js&"
import style0 from "./MyHeader.vue?vue&type=style&index=0&id=74d96886&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports